(function () {
    'use strict';

    angular
        .module('loyalty')
        .controller('LoyaltyProgramItemCreateController', LoyaltyProgramItemCreateController);

    LoyaltyProgramItemCreateController.$inject = ['LoyaltyService', '$uibModalInstance','programItems','totalItems','to'];

    function LoyaltyProgramItemCreateController(LoyaltyService, $uibModalInstance, programItems, totalItems, to) {

        var vm = this;

        vm.ok = ok;
        vm.cancel = cancel;
        vm.serviceStatus = [{id : 1, name : 'Yes'}, {id : 0, name : 'No'}];
        vm.serviceStatusSelected = {id : 1, name : 'Yes'};
        vm.form = {};
        // vm.programItems = programItems;

        function ok () {
            vm.fd = new FormData();
            vm.fd.append('description', vm.form.description);
            vm.fd.append('points', vm.form.points);
            vm.fd.append('active', vm.form.active.id);
            vm.fd.append('image', vm.form.image);

            LoyaltyService.createProgramItem(vm.fd).then(function(response) {
                alertify.notify('Service item successfully created!', 'success', 3);
                console.log(response.data);
                programItems.push(response.data);
                $uibModalInstance.close();
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }

})();